/**
 * @generated SignedSource<<e1f6fdbbfdd0f51dd9a88de8a8f8f7d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type adminDashboard_SlugSetMutation$variables = {
  id: string;
  slug: string;
};
export type adminDashboard_SlugSetMutation$data = {
  readonly adminUserSlugSet: {
    readonly activeUser: {
      readonly id: string;
      readonly publicSlug: string | null | undefined;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type adminDashboard_SlugSetMutation = {
  response: adminDashboard_SlugSetMutation$data;
  variables: adminDashboard_SlugSetMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  },
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "AdminActiveUser",
  "kind": "LinkedField",
  "name": "activeUser",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publicSlug",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "adminDashboard_SlugSetMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AdminUserSlugSetMutationPayload",
        "kind": "LinkedField",
        "name": "adminUserSlugSet",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "adminDashboard_SlugSetMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AdminUserSlugSetMutationPayload",
        "kind": "LinkedField",
        "name": "adminUserSlugSet",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ad4e68e70796eaa635086042325274af",
    "id": null,
    "metadata": {},
    "name": "adminDashboard_SlugSetMutation",
    "operationKind": "mutation",
    "text": "mutation adminDashboard_SlugSetMutation(\n  $id: ID!\n  $slug: String!\n) {\n  adminUserSlugSet(userId: $id, slug: $slug) {\n    activeUser {\n      id\n      publicSlug\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "83031cb1cece0ce65e319c2d86bc016a";

export default node;
